// extracted by mini-css-extract-plugin
module.exports = {"body":"Body_body__2sowQ","fullHeight":"Body_fullHeight__QP9IL","bottomContent":"Body_bottomContent__2RL2E"};